import { anchoMaximo } from '@/styles/constants';
import Logo from '@/assets/icons/logotipo_negro.svg';
import { Boton, Imagen, PilaH } from '@/components/atomos';
import { ChevronRight } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { CREDENCIALES } from '@/routes/AppRoutes';
import { useMediaQuery } from '@chakra-ui/react';

const CabeceraLanding = () => {
  const navigate = useNavigate();
  const [mobile] = useMediaQuery('(max-width: 768px)');

  return (
    <PilaH
      w={'full'}
      alignContent={'center'}
      justifyContent={'center'}
      borderBottom={'1px'}
      px={'2'}
      borderColor={'compo.100'}
      as='header'
      position={'fixed'}
      zIndex={100}
      shadow={'sm'}
      background={'layout'}
    >
      <PilaH as='nav' justify={'space-between'} py={'7'} w={anchoMaximo}>
        <Imagen src={Logo} alt='header-logo' w={mobile ? '8rem' : '10rem'} />
        <PilaH spacing={3}>
          {!mobile ? (
            <Boton
              variant={'outline'}
              colorScheme='bGreen'
              size={'md'}
              onClick={() => navigate(CREDENCIALES.REGISTRO)}
            >
              Registrate ahora
            </Boton>
          ) : null}
          <Boton
            variant={'action'}
            size={'md'}
            onClick={() => navigate(CREDENCIALES.INICIARSESION)}
          >
            Iniciar sesión <ChevronRight />
          </Boton>
        </PilaH>
      </PilaH>
    </PilaH>
  );
};

export default CabeceraLanding;
